import { render } from "./TableLeaveRequest.vue?vue&type=template&id=4155b6f7&scoped=true"
import script from "./TableLeaveRequest.vue?vue&type=script&lang=js"
export * from "./TableLeaveRequest.vue?vue&type=script&lang=js"

import "./TableLeaveRequest.vue?vue&type=style&index=0&id=4155b6f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4155b6f7"]])

export default __exports__